import { SelectBoxModel, Status } from 'src/app/model';

export interface SelectBoxGroupModel {
  disabled?: boolean;
  label: string;
  status: Status.ACTIVE | Status.INACTIVE;
  group: SelectBoxModel[];
}
